import "./DesignsLoading.scss";

function DesignsLoadingCard() {
  return (
    <div className={"crd"}>
      <div className={"img"} />
      <div className={"txt"} />
    </div>
  );
}

export default function DesignsLoading() {
  return (
    <div className={"designs-loading"}>
      <div className={"line"}>
        <DesignsLoadingCard />
        <DesignsLoadingCard />
        <DesignsLoadingCard />
        <DesignsLoadingCard />
        <DesignsLoadingCard />
      </div>

      <div className={"line"}>
        <DesignsLoadingCard />
        <DesignsLoadingCard />
      </div>
    </div>
  );
}
